import useAuth from 'hooks/use-auth'
import { useGremlinPagination } from 'hooks/use-gremlin-query'
import {
  DEFAULT_NOW_RUNNING_QUERY_PAGE_SIZE,
  type PaginatedQueryOptions
} from 'queries/queries-utils'
import { reliabilityTestsQueryKeys } from 'queries/reliability-tests/query-keys'

import type { ReliabilityTestsActivePagedResponse } from 'types/api/reliability-tests/active'

export function useReliabilityTestsActiveWithPagination({
  pageSize = DEFAULT_NOW_RUNNING_QUERY_PAGE_SIZE,
  ...queryOptions
}: PaginatedQueryOptions<ReliabilityTestsActivePagedResponse> = {}) {
  const { currentTeamId } = useAuth()

  return useGremlinPagination<ReliabilityTestsActivePagedResponse>(
    `reliability-tests/active/paged?pageSize=${pageSize}`,
    {},
    {
      ...queryOptions,
      queryKey: reliabilityTestsQueryKeys.getActivePaged({
        teamId: currentTeamId,
        pageSize
      })
    }
  )
}
